export enum ENUM_TIPO_USUARIO {
  ADMINISTRADOR = 1,
  REPRESENTANTE_VENDAS = 2,
  LIDERANCA_VENDAS = 3
}
